module.exports = __webpack_public_path__ + "img/使用详情.baa7f186.svg";